/**
 * RedRock Monitoring Admin BFF
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { EquipmentEventHistoryResponse } from './equipment-event-history-response';


export interface EquipmentEventHistoryResponsePagedList { 
    totalCount?: number;
    items?: Array<EquipmentEventHistoryResponse> | null;
}

